import { createAsyncThunk } from "@reduxjs/toolkit";
import * as profileApi from "../../api/requests/profile";

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      const res = await profileApi.forgotPassword(email);
      return res.data.message; // ✅ Return only the success message
    } catch (err) {
      // ✅ Return only the error message
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);
